/**
 * StripeSecured — the small "Secured by Stripe" trust footer that sits under
 * any card-capture surface. Reassures the parent that card data is handled by
 * Stripe, not us.
 *
 * Presentational only. Colors/spacing come from ChromeTokens (no raw hex/px).
 */

import { ChromeTokens } from "../chrome/tokens";
import { Icon } from "../chrome/Icon";

export function StripeSecured(): JSX.Element {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: ChromeTokens.spacing.xs + 2,
        fontSize: 11.5,
        fontFamily: ChromeTokens.font.ui,
        color: ChromeTokens.color.inkMuted,
        fontWeight: 700,
      }}
    >
      <Icon name="lock" size={12} stroke={ChromeTokens.color.inkMuted} />
      Secured by <span style={{ color: ChromeTokens.color.ink, fontWeight: 900 }}>Stripe</span>
    </div>
  );
}
